import React from "react";
import { get } from "../../api/axios";
import { postV2, patchV2, delV2, getV2 } from "../../api/axiosV2";
import {
    Container,
    Button,
    TextField
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    ValidatorForm,
    TextValidator
} from "react-material-ui-form-validator";
import { Row, Col } from "react-bootstrap";
import Loader from "../../Loader";
import { openAlert } from "simple-react-alert";
import { withRouter } from "react-router-dom";
import './cupones-style.css';

const moment = require('moment');

const AgregarCodigoCupon = props => {
    const [codigo, setCodigo] = React.useState("");
    const [cuponId, setCuponId] = React.useState(null);
    const [cupones, setCupones] = React.useState([]);
    const [limite, setLimite] = React.useState("");
    const [fechaVencimiento, setFechaVencimiento] = React.useState(null);
    const [loader, setLoader] = React.useState(false);
    const [isEditing, setIsEditing] = React.useState(false);

    React.useEffect(() => {
        // Get cupones list for autocomplete
        get("/cupones").then(response => {
            setCupones(response.data);

            // If editing, load the codigo cupon data
            if (props.editar && props.match.params.id) {
                setIsEditing(true);
                getV2("/admin/codigo-cupones/" + props.match.params.id).then(codigoResponse => {
                    const data = codigoResponse.data;
                    
                    setCodigo(data.codigo || "");
                    setLimite(data.limite ? String(data.limite) : "");
                    
                    // Handle fechaVencimiento - check both possible field names and formats
                    let fecha = null;
                    if (data.fechaVencimiento) {
                        fecha = moment(data.fechaVencimiento);
                        if (!fecha.isValid()) {
                            console.warn("Invalid fechaVencimiento format:", data.fechaVencimiento);
                        }
                    } else if (data.fecha_vencimiento) {
                        fecha = moment(data.fecha_vencimiento);
                        if (!fecha.isValid()) {
                            console.warn("Invalid fecha_vencimiento format:", data.fecha_vencimiento);
                        }
                    }
                    setFechaVencimiento(fecha && fecha.isValid() ? fecha : null);
                    
                    // Handle cupon - API may return cupon object or cuponId
                    if (data.cupon && data.cupon.id) {
                        // If cupon object is returned, find it in the list or add it if not present
                        let cupon = response.data.find(c => c.id === data.cupon.id);
                        if (!cupon) {
                            // If cupon is not in the list, add it to the list and use it
                            const updatedCupones = [...response.data, data.cupon];
                            setCupones(updatedCupones);
                            cupon = data.cupon;
                        }
                        setCuponId(cupon);
                    } else if (data.cuponId) {
                        // If only cuponId is returned, find it in the list
                        const cupon = response.data.find(c => c.id === data.cuponId);
                        if (cupon) {
                            setCuponId(cupon);
                        } else {
                            console.warn("Cupon not found in list for cuponId:", data.cuponId);
                        }
                    }
                }).catch(error => {
                    console.error("Error loading codigo cupon:", error);
                    openAlert({
                        message: "Error al cargar el código de cupón",
                        type: "danger"
                    });
                });
            }
        });
    }, [props.editar, props.match.params.id]);

    const eliminarCodigoCupon = () => {
        if (!window.confirm("¿Está seguro que desea eliminar este código de cupón?")) {
            return;
        }

        setLoader(true);
        delV2("/admin/codigo-cupones/", props.match.params.id).then(res => {
            setLoader(false);
            openAlert({
                message: "Código de cupón eliminado con éxito",
                type: "success"
            });
            props.history.goBack();
        }).catch(() => {
            setLoader(false);
            openAlert({
                message: "Error al eliminar código de cupón",
                type: "danger"
            });
        });
    };

    const handleSubmit = () => {
        // Validate cuponId
        if (!cuponId) {
            openAlert({
                message: "Debe seleccionar un cupón",
                type: "danger"
            });
            return;
        }

        setLoader(true);

        const body = {
            codigo: codigo,
            cuponId: cuponId.id,
            limite: parseInt(limite),
            fechaVencimiento: fechaVencimiento ? fechaVencimiento.format('YYYY-MM-DD').concat('T23:59:59') : null
        };

        if (isEditing) {
            // For PATCH, only send fields that are being modified
            const patchBody = {};
            if (codigo) patchBody.codigo = codigo;
            if (cuponId) patchBody.cuponId = cuponId.id;
            if (limite) patchBody.limite = parseInt(limite);
            if (fechaVencimiento) {
                patchBody.fechaVencimiento = fechaVencimiento.format('YYYY-MM-DD').concat('T23:59:59');
            } else if (fechaVencimiento === null) {
                // Allow clearing the date by sending null
                patchBody.fechaVencimiento = null;
            }

            patchV2("/admin/codigo-cupones/" + props.match.params.id, patchBody).then(res => {
                setLoader(false);
                openAlert({
                    message: "Código de cupón actualizado con éxito",
                    type: "success"
                });
                props.history.goBack();
            }).catch(error => {
                setLoader(false);
                openAlert({
                    message: "Error al actualizar código de cupón",
                    type: "danger"
                });
            });
        } else {
            postV2("/admin/codigo-cupones", body)
                .then(response => {
                    setLoader(false);
                    openAlert({
                        message: "Código de cupón creado con éxito",
                        type: "success"
                    });
                    props.history.goBack();
                })
                .catch(() => {
                    setLoader(false);
                    openAlert({
                        message: "Error al crear código de cupón",
                        type: "danger"
                    });
                });
        }
    };

    return (
        <Container className="container">
            <ValidatorForm onSubmit={handleSubmit}>
                <Row>
                    <Col xs={{ span: 8, offset: 2 }}>
                        <Row>
                            <Col xs={12} className="mb-2">
                                <TextValidator
                                    label="Código"
                                    placeholder="BIENVENIDO"
                                    value={codigo}
                                    onChange={e => setCodigo(e.target.value)}
                                    validators={["required"]}
                                    errorMessages={["Este campo es requerido"]}
                                    variant="filled"
                                    className="textInput"
                                />
                            </Col>
                            <Col xs={12} className="mb-2">
                                <Autocomplete
                                    id="cupon-autocomplete"
                                    variant="filled"
                                    onChange={(e, v) => setCuponId(v)}
                                    options={cupones}
                                    getOptionLabel={(option) => option.nombre || ""}
                                    value={cuponId}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="filled"
                                            label="Cupón"
                                            required
                                            error={!cuponId && isEditing === false}
                                            helperText={!cuponId && isEditing === false ? "Este campo es requerido" : ""}
                                        />
                                    )}
                                />
                            </Col>
                            <Col xs={6} className="mb-2">
                                <TextValidator
                                    label="Límite"
                                    placeholder="15"
                                    value={limite}
                                    onChange={e => setLimite(e.target.value)}
                                    validators={["required", "isNumber", "minNumber:1"]}
                                    errorMessages={[
                                        "Este campo es requerido",
                                        "Debe ser un número",
                                        "Debe ser mayor a 0"
                                    ]}
                                    variant="filled"
                                    className="textInput"
                                />
                            </Col>
                            <Col xs={6} style={{ marginBottom: '20px' }}>
                                <TextField
                                    id="fecha"
                                    label="Fecha de Vencimiento"
                                    type="date"
                                    value={fechaVencimiento ? fechaVencimiento.format("YYYY-MM-DD") : ""}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    className="datePicker"
                                    variant="filled"
                                    onChange={e => setFechaVencimiento(e.target.value ? moment(e.target.value) : null)}
                                />
                            </Col>
                            <Col xs={12}>
                                <div className="form-card-header">
                                    <div className="buttons-header">
                                        <Button
                                            size="large"
                                            variant="contained"
                                            className=""
                                            onClick={() =>
                                                props.history.goBack()
                                            }
                                        >
                                            Volver
                                        </Button>
                                        {loader ? (
                                            <Loader />
                                        ) : (
                                            <>
                                                <Button
                                                    size="large"
                                                    variant="contained"
                                                    type="submit"
                                                    className="ml-2"
                                                >
                                                    Guardar
                                                </Button>
                                                {isEditing && (
                                                    <Button
                                                        size="large"
                                                        variant="contained"
                                                        color="secondary"
                                                        className="ml-2"
                                                        onClick={() => eliminarCodigoCupon()}
                                                    >
                                                        Eliminar
                                                    </Button>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </ValidatorForm>
        </Container>
    );
};

export default withRouter(AgregarCodigoCupon);

